const required = (variableName, envVariable) => {
  if (envVariable === undefined) {
    throw new Error(
      `Env variable undefined: ${variableName}. Add it to any of .env files and rebuild project.`,
    );
  } else {
    return envVariable;
  }
};

// TODO: LogLevel seems to be not working on production environments. Setting warn/debug/error works locally, but not on production.
const ConfigPublic = {
  AppUrl: required('NEXT_PUBLIC_APP_URL', process.env.NEXT_PUBLIC_APP_URL),
  LogLevel: required('NEXT_PUBLIC_LOG_LEVEL', process.env.NEXT_PUBLIC_LOG_LEVEL),
  FbPixelId: required('NEXT_PUBLIC_FB_PIXEL_ID', process.env.NEXT_PUBLIC_FB_PIXEL_ID),
  GtmId: required('NEXT_PUBLIC_GTM_ID', process.env.NEXT_PUBLIC_GTM_ID),
  ArtworkDomain: required('NEXT_PUBLIC_ARTWORK_DOMAIN', process.env.NEXT_PUBLIC_ARTWORK_DOMAIN),
  VisualizationArtworkBaseUrl: required(
    'NEXT_PUBLIC_VISUALIZATION_ARTWORK_BASE_URL',
    process.env.NEXT_PUBLIC_VISUALIZATION_ARTWORK_BASE_URL,
  ),
  PublicAssetsPrefix: required('NEXT_PUBLIC_ASSETS_PREFIX', process.env.NEXT_PUBLIC_ASSETS_PREFIX),
  TrustpilotBaseUrl: required(
    'NEXT_PUBLIC_TRUSTPILOT_BASE_URL',
    process.env.NEXT_PUBLIC_TRUSTPILOT_BASE_URL,
  ),
  AthenaScriptUrl: required(
    'NEXT_PUBLIC_ATHENA_SCRIPT_URL',
    process.env.NEXT_PUBLIC_ATHENA_SCRIPT_URL,
  ),
  BuildVersion: process.env.NEXT_PUBLIC_BUILD_VER ?? 'no-version',

  // Optimove
  OptimoveSdkEnabled: required(
    'NEXT_PUBLIC_OPTIMOVE_SDK_ENABLED',
    process.env.NEXT_PUBLIC_OPTIMOVE_SDK_ENABLED,
  ),
  OptimoveSdkVersion: required(
    'NEXT_PUBLIC_OPTIMOVE_SDK_VERSION',
    process.env.NEXT_PUBLIC_OPTIMOVE_SDK_VERSION,
  ),
  OptimoveSdkToken: required(
    'NEXT_PUBLIC_OPTIMOVE_SDK_TOKEN',
    process.env.NEXT_PUBLIC_OPTIMOVE_SDK_TOKEN,
  ),
  AthenaApi: required('NEXT_PUBLIC_ATHENA_API', process.env.NEXT_PUBLIC_ATHENA_API),
  CustomerSupportBotId: required(
    'NEXT_PUBLIC_CUSTOMER_SUPPORT_BOT_ID',
    process.env.NEXT_PUBLIC_CUSTOMER_SUPPORT_BOT_ID,
  ),
  CookieConsentModeEnabled: required(
    'NEXT_PUBLIC_COOKIE_CONSENT_ENABLED',
    process.env.NEXT_PUBLIC_COOKIE_CONSENT_ENABLED,
  ),
  CookieConsentModeTag: required(
    'NEXT_PUBLIC_COOKIE_CONSENT_TAG',
    process.env.NEXT_PUBLIC_COOKIE_CONSENT_TAG,
  ),
  AthenaCookieDomain: required(
    'NEXT_PUBLIC_ATHENA_COOKIE_DOMAIN',
    process.env.NEXT_PUBLIC_ATHENA_COOKIE_DOMAIN,
  ),
};

module.exports = {
  ConfigPublic,
  required,
};
